import Phaser from "phaser";
import { GAME_WIDTH } from "../constants";
import { addCoverImage, addPanel } from "../ui/chrome";
import { MenuButton, bindMenuKeys } from "../ui/MenuButton";
import { bodyStyle, titleStyle } from "../ui/theme";
import { audioManager } from "../systems/AudioManager";

export class FarewellScene extends Phaser.Scene {
  constructor() {
    super("Farewell");
  }

  create(): void {
    audioManager.playMusic("none");
    addCoverImage(this, "menu-background");
    addPanel(this, GAME_WIDTH / 2, 360, 640, 360);
    this.add.text(GAME_WIDTH / 2, 260, "Sweet dreams.", titleStyle(40)).setOrigin(0.5).setColor("#2a1a10").setStroke("#000000", 0);
    this.add
      .text(GAME_WIDTH / 2, 330, "The forest will be here when you return.", bodyStyle(22))
      .setOrigin(0.5);

    this.tryCloseWindow();
    const back = new MenuButton(
      this,
      GAME_WIDTH / 2,
      460,
      "Return to Menu",
      () => this.scene.start("Menu"),
      240,
      "secondary",
    );
    bindMenuKeys(this, [back]);
  }

  private tryCloseWindow(): boolean {
    try {
      if (window.opener || window.history.length <= 1) {
        window.close();
        return true;
      }
    } catch {
      return false;
    }
    return false;
  }
}
